import { isEmpty, isArray } from 'lodash'

export default (http, store) => {
  // https://github.com/mzabriskie/axios#interceptors
  http.interceptors.response.use(
    response => response,
    /**
    * This is a central point to handle all
    * error messages generated by HTTP
    * requests
    */
    (error) => {
      const { response } = error
      /**
      * If token is either expired, not provided or invalid
      * then redirect to login. On server side the error
      * messages can be changed on app/Providers/EventServiceProvider.php
      */
      if ([401, 400].indexOf(response.status) > -1) {
        store.dispatch('resetMessages')
        Turbolinks.visit('/users/sign_in')
      }
      /**
      * Error messages are sent in arrays
      */
      if ([500].indexOf(response.status) > -1) {
        store.dispatch('setMessage', {
          type: 'error',
          message: ['Ops! Ocorreu um erro, tente novamente.']
        })
      }

      if ([422].indexOf(response.status) > -1 && !isEmpty(response.data.error)) {
        store.dispatch('setMessage', { type: 'validation', message: response.data.error })
      }

      store.dispatch('setFetching', { fetching: false })

      return Promise.reject(error)
    }
  )
}
